/**
 * Base Lens exception.
 */
export class LensException extends Error {
  /**
   * @param message Error message.
   */
  constructor(message: string) {
    super(message);
    this.name = "LensException";

    if (
      typeof (Error as unknown & { captureStackTrace?: unknown })
        .captureStackTrace === "function"
    ) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Error as any).captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}
